export const fontFamily = {
    default: 'Lato, sans-serif',
    heading: 'Lato, sans-serif',
};
